import type { StatusTone, TagTone } from '@/components/ui';

export function tagTone(tag: string): TagTone {
  if (tag === 'vip') return 'amber';
  if (tag === 'customer') return 'green';
  if (tag.startsWith('kategorie:')) return 'brand';
  return 'default';
}

export function ratingTone(score: number): 'red' | 'amber' | 'green' {
  if (score < 50) return 'red';
  if (score < 80) return 'amber';
  return 'green';
}

const REVIEW_LABEL: Record<string, string> = {
  requiresReview: 'To review',
  autoInvestigation: 'Investigating',
  investigated: 'Investigated',
  reviewed: 'Reviewed',
};

export function reviewLabel(status?: string | null): string | undefined {
  if (!status || status === 'none') return undefined;
  return REVIEW_LABEL[status] ?? 'Reviewed';
}

export function reviewTone(status?: string | null): 'amber' | 'green' {
  return status === 'requiresReview' || status === 'autoInvestigation' ? 'amber' : 'green';
}

export function contactStatusesOf(
  status?: { active?: boolean; doNotContact?: boolean } | null,
): StatusTone[] {
  const activity: StatusTone = status?.active ? 'active' : 'inactive';
  return status?.doNotContact ? [activity, 'dnc'] : [activity];
}
